import { render, staticRenderFns } from "./nota-print.vue?vue&type=template&id=7c96fae5&scoped=true"
import script from "./nota-print.vue?vue&type=script&lang=js"
export * from "./nota-print.vue?vue&type=script&lang=js"
import style0 from "./nota-print.vue?vue&type=style&index=0&id=7c96fae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c96fae5",
  null
  
)

export default component.exports